import { MenuProps } from "antd";
import { useMemo } from "react";
import { DropdownOptionsEventProps } from "../components/DropdownOptionsUsers/DropdownOptionsUsers";

export default function useDropdownItems({
  itemId,
  onModify,
  onDelete,
}: DropdownOptionsEventProps) {
  const items = useMemo(() => {
    const _items: MenuProps["items"] = [
      {
        key: "modify",
        onClick: () => {
          onModify(itemId);
        },
        label: "Voir/Modifier l'utilisateur",
      },
      {
        key: "delete",
        danger: true,
        label: (
          <a
            onClick={(e) => {
              e.stopPropagation();
              onDelete(itemId);
            }}
          >
            Supprimer
          </a>
        ),
      },
    ];

    return _items;
  }, [itemId, onModify, onDelete]);
  return items;
}
